<template>
    <div class="big-box">
        <div :style="`overflow: hidden;height: 564px;border-radius: 24px;background: linear-gradient(to bottom, ${ruleForm.transitionPageBgTopColor}, ${ruleForm.transitionPageBgBottomColor});`">

        </div>
        <div class="big-body">
            <img :src="tapTopUrl" alt="" class="tap-top" />
            <div :style="`width: 200px;display: flex;align-items: center;justify-content: center;align-content: center;position: absolute;top: 180px;left: 50%;transform: translateX(-50%);color: ${ruleForm.transitionPageWordColor};font-size: 12px;`">
                {{ ruleForm.transitionPageText }}
            </div>
            <div style="width: calc(520px * 0.5);height: calc(293px * 0.5);margin-top: 125px;">
                <img :src="ruleForm.transitionPageIcon" alt="" style="width: 100%;height: 100%;" />
            </div>
        </div>

        <div class="title" v-if="!oneShow">图为预览效果，以实际投效果为准</div>
    </div>
</template>
<script>
export default {
    name: "",
    components: {},
    mixins: [],
    props: {
        ruleForm: {
            type: Object,
            default: () => ({}),
        },
        oneShow: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tapTopUrl: this.$globalCdn + "/images/preview/shop_top.png",
        };
    },
    computed: {},
    watch: {},
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.big-box {
    position: relative;
    width: 300px;
    height: 580px;
    box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
    border-radius: 24px;
    border: 1px solid #ffffff;
    padding: 8px;
    z-index: 999;
    background-color: #ffffff;

    .big-box-img {
        border-radius: 24px;
        width: 284px;
        // height: 564px;
    }

    .big-body {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 99%;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;

        .buttonBtn {
            position: absolute;
            width: 186px;
            height: 32px;
            bottom: 25px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
        }

        .tap-top {
            margin-top: 8px;
        }

        .theme {
            font-weight: 600;
            font-size: 28px;
            line-height: 28px;
            margin-top: 50px;
            text-transform: none;
        }

        .desc {
            margin: 5px auto;
            width: 170px;
            height: 13px;
            font-weight: 400;
            font-size: 13px;
            text-align: center;
            line-height: 13px;
            font-style: normal;
            text-transform: none;
            margin-top: 17px;
        }

        .content {
            position: absolute;
            top: 170px;
            width: 80%;
            height: 100px;
            padding: 20px 16px;

            &-title {
                font-weight: 500;
                font-size: 12px;
                line-height: 14px;
                text-align: left;
                color: #2d2f31;
            }

            &-desc {
                margin-top: 10px;
                height: 70px;
                font-weight: 400;
                font-size: 10px;
                color: #6e6b6a;
                line-height: 18px;
                display: -webkit-box;
                /*! autoprefixer: off */
                -moz-box-orient: vertical;
                -webkit-box-orient: vertical;
                /*! autoprefixer: on */
                -webkit-line-clamp: 4; //设置超出几行省略内容
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-word; // 允许英文单词内换行
                word-wrap: break-word; // 确保长单词能够换行
            }

            &-footer {
                margin-top: 10px;
                font-weight: 500;
                font-size: 12px;
                line-height: 14px;
                text-align: right;
                font-style: normal;
                text-transform: none;
                color: #2d2f31;
            }
        }

        .action {
            position: absolute;
            top: 310px;
            width: 100%;
            height: 100px;
            text-align: center;

            .info {
                font-weight: 400;
                font-size: 8px;
                color: #ffffff;
                line-height: 10px;
                text-align: center;
                margin-top: 50px;
            }

            .btn {
                margin: 8px auto;
                position: relative;
                width: 144px;
                height: 29px;
                border-radius: 25px;

                .btn-bg {
                    width: 100%;
                    height: 100%;
                    border-radius: 25px;
                }

                &-text {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-weight: 500;
                    font-size: 12px;
                    color: #343229;
                    text-align: center;
                }
            }
        }

        .goods {
            box-sizing: border-box;
            position: absolute;
            top: 444px;
            left: 50%;
            width: 250px;
            height: 220px;
            transform: translate(-50%, 0);
            // background: rgba(255, 255, 255, 0.6);
            // box-shadow: 4px 0px 4px 0px rgba(201, 160, 166, 0.3);
            // border-radius: 12px;
            // border: 1px solid #ffffff;
            padding: 14px 0 0 14px;
            overflow-x: auto;
            overflow-y: hidden;

            &-top {
                margin-top: 14px;
                width: 80%;
                margin-left: 16px;
                position: relative;

                .line {
                    width: 100%;
                    border: 1px dashed #fd97ac;
                }

                .btn {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 65px;
                    height: 17px;
                    text-align: center;
                    line-height: 15px;
                    background: #f75073;
                    font-size: 10px;
                    color: #ffffff;
                    border-radius: 50px;
                }
            }

            &-time {
                margin-top: 16px;
                margin-right: 20px;
                // font-weight: 400;
                font-size: 8px;
                color: #2d2f31;
                line-height: 10px;
                text-align: center;
                width: 226px;
            }

            &-style {
                margin-top: 10px;
                overflow-x: auto;
                overflow-y: hidden;
                width: 238px;

                .item {
                    position: relative;
                    flex-shrink: 0;
                    margin-right: 14px;
                    width: 95px;
                    height: 120px;
                    padding: 7px 11px;
                    border-radius: 6px;
                    text-align: center;
                    // background: url("#{$globalCdn}/images/preview/goods.png") no-repeat;
                    background-size: 97px 123px;

                    &-url {
                        width: 73px;
                        height: 73px;
                        border-radius: 8px;
                    }

                    &-title {
                        margin: 2px 0 3px;
                        font-weight: 400;
                        font-size: 13px;
                        color: #2d2f31;
                        line-height: 13px;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                    }

                    &-num {
                        font-weight: 400;
                        font-size: 11px;
                        color: #999999;
                        line-height: 11px;
                    }
                }
            }

            &-item {
                display: flex;
                overflow-x: auto;
                overflow-y: hidden;
                // height: 100%;
            }

            .onetwo-style {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }

    .more-activity {
        position: absolute;
        width: 60px;
        height: 60px;
        bottom: 125px;
        right: 6px;
    }

    .title {
        margin-top: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
        text-align: center;
    }
}
</style>
